var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-quillEditor"},[_c('quill-editor',{ref:"quillEditor",attrs:{"options":_vm.editorOption},on:{"blur":_vm.tellBlurOccurred},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }